import { SET_USER_SETTING, UPDATE_USER_SETTINGS } from '../constants/actionTypes';

export const setUserSetting = ( setting, value ) => {

    return {
        type:    SET_USER_SETTING,
        payload: { setting, value }
    }

};

export const updateUserSettings = userSettings => {

    return {
        type:    UPDATE_USER_SETTINGS,
        payload: { userSettings }
    }

};